/**
 * Client-side configuration for the Scratching Post SPA.
 * @module config
 */

const config = {
  /** Application metadata. */
  app: {
    name: 'Scratching Post',
    tagline: 'Keeping you safe from harmful agentic AI behaviors',
    version: '0.1.0',
  },

  /** API base URL (empty string means same-origin). */
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || '',
  },

  /** Client-side route paths. */
  pagePaths: {
    home:           '/',
    signup:         '/signup',
    login:          '/login',
    loginWithCode:  '/login-with-code',
    changePassword: '/change-password',
    settings:       '/settings',
    dashboard:      '/dashboard',
    notLoggedIn:    '/not-logged-in',
    internalError:  '/error',
    help:           '/help',
    helpTopic:      '/help/:topicSlug',
    blog:           '/blog',
    blogPost:       '/blog/:slug',
  },
};

export default config;
